import React from 'react';
import { Button, Modal } from '../../../../Components/uielements';
import {
  TwoColumns,
  ModalButtonWrapper,
  ModalWrapper,
} from '../../../../services/settings/appStyle/global.style';
import { ModalLabel } from '../../UserV2/user.style';
import { useUserContext } from '../../../../hooks/UserContext';
import { useQuery } from 'react-query';
import Company from '../../../../services/bioplus-services/company';
import { MapWrapper } from '../company.style';
import { IntlMessages } from '../../../../helper/langHelper';

const ViewUserDetailsModal = ({ onClose, data }) => {
  const userContext = useUserContext();
  const partnerId = userContext?.company?.companyId?.id;
  const usersQuery = useQuery(['users', data._id], () =>
    Company.listOfCompanyUser(partnerId, data._id)
  );
  const userData = usersQuery.data;

  return (
    <>
      <Modal isOpen={true} onClose={onClose} title={<IntlMessages id="company.modal.title.two" />}>
        <ModalWrapper>
          {usersQuery.isLoading ? (
            <ModalLabel>
              <IntlMessages id="loading.text" />
            </ModalLabel>
          ) : (
            <>
              {userData?.items?.map((user, index) => (
                <MapWrapper key={index}>
                  <TwoColumns>
                    <ModalLabel>
                      <IntlMessages id="table.col.account.owner" /> :
                    </ModalLabel>
                    <ModalLabel isCapitalize={true}>{user?.companyName}</ModalLabel>
                  </TwoColumns>
                  <TwoColumns>
                    <ModalLabel>
                      <IntlMessages id="company.modal.user.name" /> :
                    </ModalLabel>
                    <ModalLabel>
                      {user?.userName ?? <IntlMessages id="label.not.provided" />}
                    </ModalLabel>
                  </TwoColumns>
                  <TwoColumns>
                    <ModalLabel>
                      <IntlMessages id="company.modal.user.email" /> :
                    </ModalLabel>
                    <ModalLabel>
                      {user?.email ?? <IntlMessages id="label.not.provided" />}
                    </ModalLabel>
                  </TwoColumns>
                  <TwoColumns>
                    <ModalLabel>
                      <IntlMessages id="company.modal.user.role" /> :
                    </ModalLabel>
                    <ModalLabel>{user?.role}</ModalLabel>
                  </TwoColumns>
                </MapWrapper>
              ))}
            </>
          )}
          <ModalButtonWrapper>
            <Button onClick={onClose}>
              <IntlMessages id="modal.button.close" />
            </Button>
          </ModalButtonWrapper>
        </ModalWrapper>
      </Modal>
    </>
  );
};

export default ViewUserDetailsModal;
